export interface CustomActionResponse {
  Result: CustomActionResult[];
  ResultType: ResultType;
}
export interface CustomActionResult {
  ActionType: ChangedValueModelActionType;
  ChangedValueType: ChangedValueType;
  CategoryId: string;
  LineId: number;
  PropertyName: string;
  Value: any;
  ShowSuccessMsg: boolean;
}

export enum ResultType {
  NavigateToRecordPage = 0,
  ChangedValues = 1,
  SimpleResult = 2,
  NavigateToRecordList = 3,
  ReportActionResult = 4,
  NavigateToPage = 5,
  OpenRecordList = 6,
  OpenURL = 7,
  NavigateToPaymentPage = 8,
}

export enum ChangedValueModelActionType {
  SetValue = 0,
  DeleteLine = 1,
  AddLine = 2,
  ChangeOptions = 3,
  SetSubmitConditions = 4,
}

export enum ChangedValueType {
  Single = 0,
  Object = 1,
}
